const subRegionData = {
  africa: [
    {
      name: 'North',
      initials: 'af_n',
    },
    {
      name: 'South',
      initials: 'af_s',
    },
    {
      name: 'West',
      initials: 'af_w',
    },
    {
      name: 'East',
      initials: 'af_e',
    },
    {
      name: 'Middle',
      initials: 'af_m',
    },
  ],

  americas: [
    {
      name: 'North',
      initials: 'am_n',
    },
    {
      name: 'South',
      initials: 'am_s',
    },
    {
      name: 'Central',
      initials: 'am_c',
    },
    {
      name: 'Caribbean',
      initials: 'carib',
    },
  ],

  asia: [
    {
      name: 'West',
      initials: 'as_w',
    },
    {
      name: 'East',
      initials: 'as_e',
    },
    {
      name: 'Central',
      initials: 'as_c',
    },
    {
      name: 'South',
      initials: 'as_s',
    },
    {
      name: 'South-east',
      initials: 'as_se',
    },
  ],

  europe: [
    {
      name: 'North',
      initials: 'eu_n',
    },
    {
      name: 'South',
      initials: 'eu_s',
    },
    {
      name: 'West',
      initials: 'eu_w',
    },
    {
      name: 'East',
      initials: 'eu_e',
    },
  ],

  oceania: [
    {
      name: 'Australia & NZ',
      initials: 'aus_nz',
    },
    {
      name: 'Melanesia',
      initials: 'mel',
    },
    {
      name: 'Micronesia',
      initials: 'mic',
    },
    {
      name: 'Polynesia',
      initials: 'pol',
    },
  ],
};

export default subRegionData;
